module.exports = __webpack_public_path__ + "img/103-62-floor.e2854e36.jpg";